export var SDKEnvironment = {};
export function createSDK(SDKBaseCtor, environment) {
    Object.assign(SDKEnvironment, environment);
    return SDKBaseCtor;
}
export var sdkNameToEnvName = {
    'magic-sdk': 'magic-sdk',
    '@magic-sdk/react-native': 'magic-sdk-rn',
};
//# sourceMappingURL=sdk-environment.js.map